var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "common-picture-list" }, [_vm._t("head"), _vm._v(" "), _c('resource-list', { attrs: { "resources": _vm.resources, "load": _vm.getImageComponents }, scopedSlots: _vm._u([{ key: "default", fn: function fn(_ref) {
        var resource = _ref.resource;
        return [_c('el-image', { style: "width:86px;height:86px;", attrs: { "fit": "contain", "src": resource.thumb_url, "lazy": true }, on: { "mouseenter": function mouseenter($event) {
              return _vm.show(resource.thumb_url);
            }, "mouseleave": _vm.hide } }, [_c('div', { staticClass: "image-slot", attrs: { "slot": "error" }, slot: "error" }, [_c('img', { directives: [{ name: "lazy", rawName: "v-lazy", value: _vm.defaultZip, expression: "defaultZip" }], staticClass: "image-zip", attrs: { "alt": "" } })])])];
      } }, { key: "add-button", fn: function fn(_ref2) {
        var resource = _ref2.resource;
        return [_c('add-resource-to-playable', { attrs: { "resource": resource }, on: { "addResource": _vm.handleAddResource } })];
      } }, { key: "title", fn: function fn(_ref3) {
        var resource = _ref3.resource;
        return [_c('div', { staticClass: "resource-title", attrs: { "title": resource.name } }, [_vm._v("\n        " + _vm._s(resource.name) + "\n      ")])];
      } }]) })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };